import React from 'react';

import UserInfo from '@pages/UserInfo';
import { FCWithChildren } from '@types';

const Register: FCWithChildren<{}> = () => <UserInfo isRegistering path="/register" />;

export default Register;
